(function ($) {
  DJ.addBehavior('sectionNavigation', '.js-section-navigation', {
    attach: function () {
      const navContainer = this;
      const navInnerClass = 'section-navigation__inner';
      const navInnerClassMob = 'section-navigation--mobile';
      const hideButtonMob = 'section-navigation__mobile-btn--hide';
      const navInner = navContainer.querySelector(`.${navInnerClass}`);
      const mobileButtonTextContainer = navContainer.querySelector(
        '.section-navigation__text-for-mobile-btn'
      );
      const mobileButton = navContainer.querySelector(
        '.section-navigation__mobile-btn'
      );
      const buttonClose = navContainer.querySelector(
        '.section-navigation__btn-close'
      );

      if (mobileButton && mobileButtonTextContainer) {
        mobileButton.textContent = mobileButtonTextContainer.textContent;
        mobileButton.addEventListener('click', () => {
          if (navInner) {
            if (navInner.classList.contains(`${navInnerClass}--show`)) {
              navInner.classList.remove(`${navInnerClass}--show`);
              navContainer.classList.remove(navInnerClassMob);
            } else {
              navInner.classList.add(`${navInnerClass}--show`);
              navContainer.classList.add(navInnerClassMob);
              mobileButton.classList.add(hideButtonMob);
            }
          }
        });
      }

      if (buttonClose) {
        buttonClose.addEventListener('click', () => {
          navInner.classList.remove(`${navInnerClass}--show`);
          navContainer.classList.remove(navInnerClassMob);
          mobileButton.classList.remove(hideButtonMob);
        });
      }
    },
  });
})(jQuery);
